<template>
  <v-overlay v-if="modals.length>0">
    <component :is="modal.type"  :params="modal.params" @closed="closed"/>
  </v-overlay>
</template>
<script>
export default {
  data(){
    return {
      modal:undefined
    }
  },
  components:{
    NewOrder:()=>import('@/components/base/modals/NewOrder.vue')
  },
  computed:{
    modals(){
      return this.$store.getters.getModals
    }    
  },  
  watch:{
    modals(newVal){
      this.modal = newVal[0]
    }
  },
  methods:{
    closed(){
      this.$store.commit('popModal')
    }
  }

  
}
</script>